import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeletePostsMutation } from "../graphql/mutations";
import type { DeletePostsMutationType } from "@/types/graphql/partner.generated";

export const useDeletePostsMutation = (
  options?: MutationHookOptions<DeletePostsMutationType>
) => {
  return useMutation<DeletePostsMutationType>(DeletePostsMutation, options);
};
